import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, Stack, Typography } from "@mui/material";
import { ReactNode, useContext, useState } from "react";

import EditIcon from '@mui/icons-material/Edit';
import { Attribute, PlayerCharacter } from "../model/character";
import { StatBox } from "./StatBox";
import { NumberField } from "./formFields/NumberField";
import { CharacterContext } from "../model/characterContext";

import HexagonIcon from '@mui/icons-material/Hexagon';

import styled from 'styled-components';
import { Modal } from "./Modal";
import FormFieldLabel from "./formFields/FormFieldLabel";

const Hexagon = styled.div`
    width: 55px;
    height: 55px;
    margin: 0 auto;
    position: relative;
    cursor: pointer;
`;

const HexagonNumber = styled.div`
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    font-size: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff
`;

const HexagonSide = styled.div`
    display: flex;
    position: absolute;
    left: 65px;
    top: 0px;
    bottom: 0px;
    width:15px;
    flex-direction: column;
    justify-content: center;
    &>*:not(:first-child) {
        margin-top: 5px;
    }
`;

interface AttributeFieldProps {
    value: Attribute;
    showExtended?: boolean;
    last?: boolean;
    character: PlayerCharacter;
    onChange: (value: Attribute) => void;
}

const SkillRow = (props: {name: ReactNode, value: ReactNode, control?: ReactNode }) => {
    return <Box><Grid container height="33px" spacing={1} paddingLeft={1}>
        <Grid item xs={8}>{props.name}</Grid>
        <Grid item xs={2}>{props.value}</Grid>
        <Grid item xs={2} textAlign="right" alignItems="center">{props.control}</Grid>
    </Grid></Box>
}

export const AttributeField = (props: AttributeFieldProps) => {
    const characterContext = useContext(CharacterContext)!;
    const { value, character, onChange } = props;

    const [ attributeValue, setAttributeValue ] = useState(value);
    const [ editing, setEditing ] = useState(false);

    const handleSubmit = () => {
        onChange(attributeValue);
        setEditing(false);
    }

    const handleCancel = () => {
        setAttributeValue(value);
        setEditing(false);
    }

    //const total = (value.trained ? 1: -2) + (value.toolbox ? 1 : 0) + (value.workshop ? 1 : 0);
    const max = attributeValue.max + characterContext.getAdjustment(`${value.id}_max`);
    const bonus = characterContext.getAdjustment(`${value.id}`)

    let skillsLeft = 18;
    for(var attr of character.attributes) {
        if(attr.id !== attributeValue.id)
            skillsLeft -= attr.alloted;
    }

    const current = Math.min(props.value.alloted, max) + bonus;

    return <>
        <Modal maxWidth="xs" open={editing} onClose={handleCancel} title={value.name} actions={[
                    { label: "Cancel", onClick: handleCancel },
                    { label: "Modify", onClick: handleSubmit, primary: true },
                ]}>
            <FormGroup>
                <Stack spacing={1}>
                    <SkillRow name="Attribute points left:" value={skillsLeft - attributeValue.alloted} />
                    <FormFieldLabel label="Alloted:" justifyContent="end">
                        <NumberField step={1} min={0} max={Math.min(max, skillsLeft)} value={attributeValue.alloted} onChange={(v) => setAttributeValue(current => { return { ...current, alloted : v}} )} />
                    </FormFieldLabel>
                </Stack>
            </FormGroup>
        </Modal>
        
        <Grid item xs={4} sm={4} onClick={() => setEditing(true)} marginBottom={2}>
            <Hexagon>
                <HexagonNumber>
                    <Box fontSize="55px"><HexagonIcon fontSize="inherit" color="primary" /></Box>
                </HexagonNumber>
                <HexagonNumber>
                    {current}
                </HexagonNumber>
            </Hexagon>
            <Typography variant="body1" textAlign={"center"}>{value.name}</Typography>
        </Grid>
    </>
}